import React from 'react';
import './NavbarItem.css';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const NavbarItem = (props) => {
    const { id, mainLink, subLink, isActive, onNavLinkClick } = props;

    const hasSublinks = subLink && subLink.length > 0;

    return (
        <div className="nav-link">
            {/* Główny kontener linku */}
            <div 
                className={`main-nav-link ${isActive ? 'active' : ''}`} 
                onClick={() => onNavLinkClick(id)}
            >
                {/* Jeśli są sublinki, renderujemy tekst, jeśli nie - zwykły Link */}
                {hasSublinks ? (
                    <span className="nav-btn">{mainLink.title}</span>
                ) : (
                    <Link className="nav-btn" to={mainLink.link}>
                        {mainLink.title}
                    </Link>
                )}

                {/* Ikona plus/minus tylko gdy są sublinki */}
                {hasSublinks && (
                    <div className="icon">
                        {isActive ? <FaMinus /> : <FaPlus />}
                    </div>
                )}
            </div>

            {/* Sub-nawigacja - renderowana tylko gdy aktywna i są elementy */}
            {isActive && hasSublinks && (
                <div className="sub-nav-link">
                    {subLink.map((item) => (
                        <Link to={item.link} state={item.state} key={item.id}>
                            {item.title}
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default NavbarItem;